module.exports = __webpack_public_path__ + "img/lesser_demon_cage_small.5877114b.png";